import React from 'react';
import { Card, Row, Col, Typography, Button } from 'antd';

const { Title, Text } = Typography;

interface DomainSelectorProps {
  onDomainSelect: (domain: string, title: string) => void;
  selectedDomain?: string;
}

const DomainSelector: React.FC<DomainSelectorProps> = ({ 
  onDomainSelect, 
  selectedDomain 
}) => {
  const domains = [
    {
      key: 'painting',
      title: '古書畫鑑定',
      description: '書法、繪畫作品的真偽鑑別與年代考證',
      color: '#1890ff'
    },
    {
      key: 'porcelain',
      title: '古瓷器鑑定',
      description: '陶瓷器物的窯口、年代與工藝分析',
      color: '#52c41a'
    },
    {
      key: 'bronze',
      title: '青銅器鑑定',
      description: '青銅文物的時代特徵與鑄造工藝',
      color: '#eb2f96'
    },
    {
      key: 'jade',
      title: '玉器鑑定',
      description: '玉石材質、雕工與文化內涵分析',
      color: '#13c2c2'
    },
    {
      key: 'calligraphy',
      title: '書法篆刻',
      description: '書法作品與印章的風格流派鑑定',
      color: '#722ed1'
    },
    {
      key: 'antique',
      title: '雜項古玩',
      description: '各類古董文物的綜合性鑑定',
      color: '#faad14'
    }
  ];

  return (
    <div style={{ padding: '24px 0' }}>
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <Title level={2} style={{ color: '#262626', marginBottom: '8px' }}>
          專業鑑定領域
        </Title>
        <Text type="secondary" style={{ fontSize: '16px' }}>
          選擇您需要鑑定的文物藝術品類別，獲得專業的AI輔助分析
        </Text>
      </div>
      
      <Row gutter={[24, 24]}>
        {domains.map((domain) => (
          <Col xs={24} sm={12} md={8} key={domain.key}>
            <Card
              hoverable
              style={{
                borderColor: selectedDomain === domain.key ? domain.color : '#d9d9d9',
                borderWidth: selectedDomain === domain.key ? 2 : 1,
                height: '180px',
                cursor: 'pointer'
              }}
              bodyStyle={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                height: '100%'
              }}
            >
              <Title level={4} style={{ 
                color: domain.color,
                marginBottom: '12px'
              }}>
                {domain.title}
              </Title>
              
              <Text type="secondary" style={{ 
                fontSize: '14px', 
                marginBottom: '16px',
                flex: 1
              }}>
                {domain.description}
              </Text>
              
              <Button 
                type={selectedDomain === domain.key ? 'primary' : 'default'}
                style={{ 
                  backgroundColor: selectedDomain === domain.key ? domain.color : undefined,
                  borderColor: domain.color,
                  color: selectedDomain === domain.key ? 'white' : domain.color
                }}
                onClick={() => onDomainSelect(domain.key, domain.title)}
                block
              >
                選擇此領域
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default DomainSelector;